/*
  grid-zip-documents.js

  As of server v4.11.0.3759 if a grid has document links,
  the server will create a download as zip link, which
  is added to the grid object in JSON.

  This plugin looks for that link and creates a
  button to let users download the zip.

  Author: Tim Bauwens
  Copyright: Berkeley Bridge 2021

*/

import { _ } from "$json";
import { has } from "ramda";

_.addTranslations({
  download: {
    "en": "Download all documents as ZIP",
    "nl": "Download alle documenten als ZIP",
    "en-GB": "Download all documents as ZIP"
  }
});

((doc, $) => {
  $(doc).on("bb:postHandleData", (e, data) => {
    if (data && data.groups) {
      data.groups.forEach(group => {
        group.controls &&
          group.controls.forEach(control => {
            if (
              control.controltype === "grid" &&
              has("zipdocumenturl")(control)
            ) {
              let btn = doc.createElement("a");
              btn.href = control.zipdocumenturl;
              btn.innerText = _("download");
              btn.className = "p-grid-zip-documents";

              doc
                .getElementById(control.id)
                .insertAdjacentElement("afterEnd", btn);
            }
          });
      });
    }
  });
})(document, jQuery);
